import Vue from "vue"
import App from "./App.vue"
import store from "./store"
import axios from "axios"
import router from "./router"
import vuetify from "./plugins/vuetify"
import VuePageTransition from "vue-page-transition"
import "./assets/app.css"
import './registerServiceWorker'

Vue.use(VuePageTransition)

// axios.defaults.baseURL =
//   localStorage.getItem("ip_address") || "https://apidev.clockin.id/api/v1/"
axios.defaults.headers.common["Authorization"] = localStorage.getItem("token")
axios.defaults.baseURL = "https://opprim.frontdave.com/api"
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app")

// store.dispatch("Auth/attempt", localStorage.getItem("token")).then(() => {

// })
